import ROUTES from "@/settings/routes";
import { userRoleNames } from "@/settings/userManagement";

export interface AclType {
  isDefault?: boolean;
  permissions?: string[];
}

export const aclSettings: Record<string, Record<string, Record<string, AclType>>> = {
  [userRoleNames.admins]: {
    pages: {
      [ROUTES.DASHBOARD.PATH]: {},
      [ROUTES.ADVERTISERS_MANAGEMENT.PATH]: {},
      [ROUTES.ACCOUNT_MANAGEMENT.PATH]: {},
      [ROUTES.USER_MANAGEMENT.PATH]: {},
      [ROUTES.PLATFORM.PATH]: {},
      [ROUTES.SETTINGS.PATH]: {},
      [ROUTES.CREATE_NEW_PAGE.PATH]: {},
      [ROUTES.EDIT_PAGE.PATH]: {},
      [ROUTES.TEMPLATE_MANAGEMENT.PATH]: {},
      [ROUTES.PROJECT_TEMPLATE_MANAGEMENT.PATH]: {},
      [ROUTES.SELECT_FLOW.PATH]: { isDefault: true },
      [ROUTES.PLAN.PATH]: {},
      [ROUTES.COMPARE.PATH]: {},
      [ROUTES.CREATE_NEW_PLAN.PATH]: {},
      [ROUTES.PROJECT.PATH]: {},
      [ROUTES.EDIT_PROJECT_LAYOUT.PATH]: {},
      [ROUTES.EDIT_PROJECT_INPUT.PATH]: {},
      [ROUTES.EDIT_PLAN.PATH]: {},
    },
  },
  [userRoleNames.armUsers]: {
    pages: {
      [ROUTES.ADVERTISERS_MANAGEMENT.PATH]: {},
      [ROUTES.DASHBOARD.PATH]: {},
      [ROUTES.CREATE_NEW_PAGE.PATH]: {},
      [ROUTES.EDIT_PAGE.PATH]: {},
      [ROUTES.SELECT_FLOW.PATH]: { isDefault: true },
      [ROUTES.PLAN.PATH]: {},
      [ROUTES.COMPARE.PATH]: {},
      [ROUTES.CREATE_NEW_PLAN.PATH]: {},
      [ROUTES.PROJECT.PATH]: {},
      [ROUTES.EDIT_PROJECT_LAYOUT.PATH]: {},
      [ROUTES.PROJECT_TEMPLATE_MANAGEMENT.PATH]: {},
      [ROUTES.EDIT_PROJECT_INPUT.PATH]: {},
      [ROUTES.EDIT_PLAN.PATH]: {},
    },
  },
  [userRoleNames.users]: {
    pages: {
      [ROUTES.DASHBOARD.PATH]: {},
      [ROUTES.CREATE_NEW_PAGE.PATH]: {},
      [ROUTES.EDIT_PAGE.PATH]: {},
      [ROUTES.SELECT_FLOW.PATH]: { isDefault: true },
      [ROUTES.PLAN.PATH]: {},
      [ROUTES.COMPARE.PATH]: {},
      [ROUTES.CREATE_NEW_PLAN.PATH]: {},
      [ROUTES.PROJECT.PATH]: {},
      [ROUTES.EDIT_PROJECT_LAYOUT.PATH]: {},
      [ROUTES.PROJECT_TEMPLATE_MANAGEMENT.PATH]: {},
      [ROUTES.EDIT_PROJECT_INPUT.PATH]: {},
      [ROUTES.EDIT_PLAN.PATH]: {},
    },
  },
};
